import { z } from 'zod';

const schema = z.object({
  VITE_API_URL: z.url(),
  VITE_SUPABASE_URL: z.url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
  VITE_MENTOR_ENABLED: z.enum(['true', 'false']).default('false'),
});

const parsed = schema.safeParse(import.meta.env);
if (!parsed.success) {
  throw new Error(
    `Missing or invalid VITE_* environment: ${parsed.error.issues.map((i) => i.path.join('.')).join(', ')}`,
  );
}

/** Browser-safe configuration. Only VITE_* keys ever reach this bundle. */
export const env = parsed.data;
